import { html, rune, View } from 'rune-ts';
import klass from './AdSection.module.scss';
import { ButtonArrow } from '../../../../components/atoms/ButtonArrow/ButtonArrow';
import { htmlIf } from '../../../../../shared/util';
import { AdCard } from './AdCard';
import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import { map, pipe, range, toArray } from '@fxts/core';
import { SwiperOptions } from 'swiper/types/swiper-options';

export class AdSection extends View {
  swiper?: Swiper;

  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    return html`
      <section class="${klass.ad} swiper ad_swiper">
        <div class="swiper-wrapper ${klass.swiper_wrapper}">${this._renderCardList()}</div>

        ${htmlIf(
          html`<div class="${klass.buttons}">
            ${new ButtonArrow({ type: 'blue', direction: 'left' })}
            ${new ButtonArrow({ type: 'blue', direction: 'right' })}
          </div>`,
          !is_mobile,
        )}
        ${htmlIf(html`<div class="swiper-pagination ${klass.pagination}"></div>`, is_mobile)}
      </section>
    `;
  }

  override onRender() {
    this.swiper = this._onLoadAdSwiper();
  }

  private _onLoadAdSwiper() {
    return new Swiper('.ad_swiper', this._createSwiperOption());
  }

  private _createSwiperOption(): SwiperOptions {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    if (is_mobile) {
      return {
        modules: [Pagination, EffectFade],
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: `${klass.bullet} swiper-pagination-bullet`,
          bulletActiveClass: `${klass.bullet_active} swiper-pagination-bullet-active`,
        },
      };
    } else {
      return {
        modules: [Navigation, EffectFade],
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        allowTouchMove: false,
        simulateTouch: false,
        navigation: {
          nextEl: 'button.right',
          prevEl: 'button.left',
        },
      };
    }
  }

  private _renderCardList() {
    return pipe(
      range(1, 5),
      map((page) => new AdCard({ page })),
      map((AdCard) => html`<div class="swiper-slide">${AdCard}</div>`),
      toArray,
    );
  }
}
